var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from "react-router-dom";
export default (function (props) {
    return props.isExternal ? (_jsx("a", __assign({ href: props.to, className: props.className }, { children: props.children }))) : (_jsx(RouterLink, __assign({ to: props.to, className: props.className }, { children: props.children })));
});
//# sourceMappingURL=index.js.map